import React from "react";
import _ from "lodash";
import moment from "moment";
import "./index.less";

export default props => {
  const { userDetails: { activity = [] } = {} } = props;

  const numLogins = activity
    .map(obj => obj && obj.action === "login")
    .filter(n => n).length;
  const days = _.keys(
    activity.reduce((acc, item) => {
      const result = { ...acc };
      const { actionDate } = item || {};
      if (actionDate) {
        const [day] = actionDate.split(" ");
        result[day] = 1;
        return result;
      }
      return null;
    }, {})
  )
    .sort()
    .reverse();

  let currentStreak = 1;
  let longestStreak = 1;
  let streak = 1;
  let endOfCurrentStreak = false;
  for (let x = 0; x < days.length; x++) {
    if (x < days.length - 1) {
      const currentDay = moment(days[x], "YYYY-MM-DD");
      const nextDay = moment(days[x + 1], "YYYY-MM-DD");
      const nextCalcDay = currentDay.subtract(1, "days");
      if (nextDay.isSame(nextCalcDay)) {
        if (!endOfCurrentStreak) currentStreak++;
        streak++;
        if (streak > longestStreak) longestStreak = streak;
      } else {
        endOfCurrentStreak = true;
        streak = 1;
      }
    }
  }

  const sections = [
    {
      name: "Session",
      value: numLogins,
      unit: "",
      backgroundColor: "#632d8c",
      color: "#fff"
    },
    {
      name: "Longest Streak",
      value: longestStreak,
      unit: "days",
      backgroundColor: "#0476bc",
      color: "#fff"
    },
    {
      name: "Current Streak",
      value: currentStreak,
      unit: "days",
      backgroundColor: "#87b949",
      color: "#fff"
    }
  ];
  const winWidth = sections.length * 130;
  return (
    <section className="progress" style={{ width: `${winWidth}px` }}>
      <div className="progress-header ">Progress</div>
      <div className="progress-body">
        <ul>
          {sections.map(section => {
            const { name, value, unit, backgroundColor, color } = section;
            return (
              <li key={name}>
                <div className="list-container">
                  <div className="name">{name}</div>
                  <div className="circle" style={{ backgroundColor, color }}>
                    <div className="value">{value}</div>
                    <div className="unit">{unit}</div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
